const translations = {
    "Back": ["Back", "Zurück"],
    "Clear stage": ["Clear stage", "Bühne leeren"],
    "col1": ["Color 1", "Farbe 1"],
    "col2": ["Color 2", "Farbe 2"],
    "Copied link!": ["Copied link!", "Link kopiert!"],
    "Copyright_headline": ["Copyright", "Copyright"],
    "Copyright_text": [
        `
        
        Every drawing in this tool was created by Janina Himmen and is protected by copyright. 
        This is a non-commercial fan project inspired by the art style of the cartoon South Park. 
        Please mention sp-studio.de as a source when you share the images. If you do so, you may hide the watermark.
        If you want to use the pictures for your own projects, have a look at the <a href="https://www.sp-studio.de/w/faq/#terms" target="_blank">terms of use</a> first.`,
        `Alle Zeichnungen im SP-Studio wurden von Janina Himmen erstellt und sind urheberrechtlich geschützt. 
        Es handelt sich hierbei um ein nicht-kommerzielles Fanprojekt, inspiriert durch den Stil der Serie South Park.
        Bitte gib SP-Studio.de als Quelle an, wenn du die Bilder teilst. Dann darfst du das Wasserzeichen ausblenden.
        Bei Fragen zur Verwendung der Bilder findest du hier die <a href="https://www.sp-studio.de/w/faq/#terms" target="_blank">Nutzungsbedingungen</a>.`
    ],
    "Copy the link": ["Copy the link", "Link kopieren"],
    "Delete": ["Delete", "Löschen"],
    "Download as image": ["Download as image", "Als Bild herunterladen"],
    "Flip": ["Flip", "Spiegeln"],
    "Grab this link to save your character for later or to share it with others.": [
        "Grab this link to save your character for later or to share it with others.",
        "Schnapp dir diesen Link, um deinen Charakter für später zu speichern oder mit anderen zu teilen."
    ],
    "I agree to the terms, please remove the watermark.": [
        "I agree to the terms, please remove the watermark.",
        "Ich stimme der Vereinbarung zu, bitte entferne das Wasserzeichen."
    ],
    "Imprint": ["Imprint", "Impressum"],
    "Info_headline": ["Welcome to the new SP-Studio!", "Willkommen im neuen SP-Studio!"],
    "Info_text": [
        `The SP-Studio is the biggest create-a-character tool online, and even 19 years
        after its launch there are updates with new content. <span class="mobilehide">Create a cute cartoon-
        look-a-like of yourself, friends or celebrities and dress it up! It's easy to use,
        but offers endless options for customization.</span>`,
        `Das SP-Studio ist der webweit umfangreichste Charakter-Baukasten, und nach 19 Jahren 
		gibt es immer noch regelmäßige Updates. <span class="mobilehide">Bastle niedliche Cartoon-Versionen von dir, 
		deinen Freunden oder Berühmtheiten und kleide sie ein! Leicht zu bedienen,
		aber mit unzähligen Möglichkeiten, kreativ zu sein.</span>`
    ],
    "Info_point_1_lead": [
        `Click on the skin of the character to change its color.`,
        `Klicke den Körper der Figur an, um die Hautfarbe zu ändern.`
    ],
    "Info_point_1_text_a": [
        `The item options let you customize your picture in many ways.
        You can also use`,
        `Die Item-Optionen lassen dich dein Bild freier gestalten.
        Verwende`
    ],
    "Info_point_1_text_b": [
        `to access everything currently in use.`,
        `, um alles aufzulisten, was bisher eingefügt wurde.`
    ],
    "Info_point_2_lead": [
        `Click on the category icons to add more items to the picture.`,
        `Klicke auf die Kategorie-Symbole, um neue Items hinzuzufügen.`
    ],
    "Info_point_2_text": [
        `There are many categories for clothes, hairstyles, backgrounds
        and more. In the mobile version you can find them here:`,
        `Es gibt viele verschiedene Kategorien für Kleidung, Frisuren,
		Hintergründe und mehr. In der mobilen Version findet du sie hier:`
    ],
    "Info_point_3_lead": [`Have fun!`, `Viel Spaß!`],
    "Info_point_3_text": [
        `The <a href="https://www.sp-studio.de/w/faq/" target="_blank" rel="noopener noreferrer">F.A.Q.</a> will help you with any questions. <span class="mobilehide">They also explain how to combina any items with the awesome new "lock" button.</span>`,
        `Die <a href="https://www.sp-studio.de/w/faq/" target="_blank" rel="noopener noreferrer">F.A.Q.</a> helfen dir bei Fragen weiter. <span class="mobilehide">Dort wird auch erklärt, wie du mit der neuen "Sperren" Funktion beliebige Items kombinierst.</span>`
    ],
    "Let's start…": ["Let's start…", "Los geht's…"],
    "Loading": ["Loading…", "Lädt…"],
    "Lock": ["Lock", "Sperren"],
    "Locked": ["Locked", "Gesperrt"],
    "No items yet": ["No items yet", "Noch keine Items"],
    "Privacy policy": ["Privacy policy", "Datenschutz"],
    "Rotate": ["Rotate", "Drehen"],
    "Save your character": ["Save your character", "Sichere deinen Charakter"],
    "Undo delete": ["Undo delete", "Rückgängig machen"]
} as { [key: string]: string[] };

export function getCulture(countryCode?: string): string {
    let systemCulture = "en-US"
    let culture = systemCulture

    if (typeof window !== "undefined" && typeof window.navigator !== "undefined") {
        systemCulture = ((window.navigator.language).toLowerCase().indexOf("de") > -1 ? "de-DE" : "en-US")
    }

    if (typeof localStorage !== "undefined") {
        culture = (localStorage.getItem("culture") ? localStorage.getItem("culture") : systemCulture) as string
    }

    countryCode = countryCode || culture
    return countryCode
}

export type Language = "en" | "de"

export function getLanguage(countryCode?: string): Language {
    countryCode = getCulture(countryCode)
    const lang = countryCode.substr(0, 2)
    if (lang === "en" || lang === "de") {
        return lang
    }
    else {
        return "en"
    }
}

export function getPhrase(keyword: string, countryCode?: string): string {
    countryCode = getCulture(countryCode)

    if (translations[keyword]) {
        if (countryCode.indexOf("de-") > -1) {
            return translations[keyword][1]
        }
        else {
            return translations[keyword][0]
        }
    }
    else {
        return keyword
    }
}
